const createOrder = () =>
  new Vue({
    data: () => {
      return {
        urlList: {
          list: "web.CustomerService/QueryCustomerOrders",
          detail: "web.CustomerService/GetCustomerOrder",
          line: "web.CustomerService/GetCustomerOrderLines",
        },
        page: 1,
        size: 10,
        total: 0,
        inputValue: 1,
        orderList: [],
        order: null,
        lineItems: [],
        nodata: false,
        activeIndex: 0,
        status: "",
        showDetail: false,
        orderId: "",
        showAllLineItems: false,
        adapter: new StorageAdapter(),
        shopify: new ShopifyRelatedV2(),
        localKey: "cartItems",
        selectedItems: [], // 存储已选中的行项目ID
        selectAll: false, // 全选状态
        trackingInfo: [], // 物流列表
      };
    },
    created() {
      const params = theme.getAllUrlParameters();
      if (params.orderId) {
        this.showDetail = true;
        this.orderId = params.orderId;
        this.fetchOrderDetail();
        this.fetchOrderLine();
      } else {
        this.fetchGetOrderList();
      }
    },
    computed: {
      totalPages() {
        return Math.ceil(this.total / this.size);
      },
      // 是否显示左省略号
      showLeftEllipsis() {
        return this.totalPages > 7 && this.page > 4;
      },
      // 是否显示右省略号
      showRightEllipsis() {
        return this.totalPages > 7 && this.page < this.totalPages - 3;
      },
      // 中间显示的页码
      middlePages() {
        const pages = [];
        if (this.totalPages <= 7) {
          // 总页数小于等于7，显示所有页码
          for (let i = 2; i < this.totalPages; i++) {
            pages.push(i);
          }
        } else {
          let start, end;

          if (this.page <= 4) {
            // 当前页靠近开始
            start = 2;
            end = 7;
          } else if (this.page >= this.totalPages - 3) {
            // 当前页靠近结束
            start = this.totalPages - 6;
            end = this.totalPages - 1;
          } else {
            // 当前页在中间
            start = this.page - 2;
            end = this.page + 2;
          }

          for (let i = start; i <= end; i++) {
            pages.push(i);
          }
        }
        return pages;
      },
    },
    methods: {
      fetchGetOrderList() {
        const params = {
          pageSize: {
            page: this.page,
            size: this.size,
          },
        };
        if (this.status) params.financialStatus = this.status;
        fetchConnect(this.urlList.list, "POST", params).then((response) => {
          if (!response.error && response.data?.items) {
            this.orderList = response.data?.items;
            this.total = response.data?.total;
            this.nodata = this.total == 0 ? true : false;
          } else {
            this.nodata = true;
          }
        });
      },
      // 返回产品url
      productUrl(item) {
        return `/products/${item?.handle}`;
      },
      // 根据接口返回的数据进行价格格式化，若为美元则直接转为其他币种，若为其他币种则直接显示，不转化
      formatPrice(item) {
        const symbol = CURRENCY_SYMBOLS[item?.currencyCode || "USD"];
        return `${symbol}${item?.amount || 0}`;
      },
      clickTab(index, key) {
        this.activeIndex = index;
        this.status = index == 0 ? "" : key;
        this.orderList = [];
        this.fetchGetOrderList();
      },
      prevPage() {
        if (this.page > 1) {
          this.page--;
          this.inputValue = this.page;
          this.fetchGetOrderList();
        }
      },
      nextPage() {
        if (this.page < this.totalPages) {
          this.page++;
          this.inputValue = this.page;
          this.fetchGetOrderList();
        }
      },
      goToPage(pageNumber) {
        let number = Number(pageNumber);
        if (number > this.totalPages) {
          number = this.totalPages;
        }
        if (number < 1) {
          number = 1;
        }
        this.inputValue = number;
        this.page = number;
        this.fetchGetOrderList();
      },
      async addOrderToCart(orderId) {
        await this.fetchOrderLine(orderId);
        const list = this.handleData(this.lineItems);
        this.addToCartRequest(list);
      },
      // 将订单中选中的产品加入购物车
      addSelectedToCart() {
        const list = this.handleData(this.selectedItems);
        if (list.length == 0) return;
        this.addToCartRequest(list);
      },
      // 将订单中的某个产品加入购物车
      addLineItemToCart(order) {
        if (!order.productId) return;
        const list = this.handleData(order);
        if (list.length == 0) return;
        this.addToCartRequest(list);
      },
      // 处理加购数据
      handleData(list) {
        const result = [];
        const typeStr = Object.prototype.toString.call(list);
        if (typeStr === "[object Object]") {
          list = [list];
        }
        for (let item of list) {
          if (item?.productId) {
            const data = {
              variant_id: item?.variantId,
              quantity: item?.quantity,
              checked: true,
              final_price: item?.originalTotalSet.shopMoney.amount,
              id: item?.variantId,
              url: item?.url,
              product_id: item?.productId,
              product_title: item?.title,
              featured_image: item?.featuredImage,
              variant_options: item?.variant?.selectedOptions,
              weight: item?.variant?.weight,
            };
            result.push(data);
          }
        }

        return result;
      },
      async addToCartRequest(list) {
        const message = document.getElementById("promptMessage"); //添加成功
        const items = await this.adapter.create({
          key: this.localKey,
          value: list,
        });
        if (items) {
          message.classList.remove("hidden");
          message.classList.add("show");
          var timer = setTimeout(() => {
            clearTimeout(timer);
            message.classList.remove("show");
            message.classList.add("hidden");
          }, 2000);
          this.selectedItems = [];
          this.selectAll = false;
        }

        if (items && cartPop) {
          cartPop.cartList = items;
          cartPop.shopifyCartData = await this.shopify.create(items);
          theme.reportAddToCart(items);
          cartPop.handleDataList();
        }
      },
      async fetchOrderDetail() {
        const response = await fetchConnect(this.urlList.detail, "POST", {
          id: this.orderId,
        });

        if (!response.error) {
          this.order = response.data;
          this.processTrackingInfo();
        }
      },
      async fetchOrderLine(orderId) {
        const response = await fetchConnect(this.urlList.line, "POST", {
          id: orderId || this.orderId,
          pageSize: {
            page: 1,
            size: 250,
          },
        });

        if (!response.error) {
          this.lineItems = response.data?.items;
        }
      },
      // 在methods对象中添加以下方法
      processTrackingInfo() {
        this.trackingInfo = [];

        // 检查order和fulfillment是否存在
        if (
          !this.order ||
          !this.order.fulfillment ||
          !Array.isArray(this.order.fulfillment)
        ) {
          return;
        }

        // 用于存储已处理的跟踪号，用于去重
        const processedNumbers = new Set();

        // 遍历所有fulfillment
        this.order.fulfillment.forEach((fulfillment) => {
          // 检查trackingInfo是否存在且为数组
          if (
            fulfillment.trackingInfo &&
            Array.isArray(fulfillment.trackingInfo)
          ) {
            // 遍历trackingInfo
            fulfillment.trackingInfo.forEach((tracking) => {
              // 如果跟踪号不为空且未处理过
              if (tracking.number && !processedNumbers.has(tracking.number)) {
                // 添加到已处理集合
                processedNumbers.add(tracking.number);

                // 添加到trackingInfo数组
                this.trackingInfo.push({
                  company: tracking.company || "",
                  number: tracking.number,
                  url: tracking.url || "",
                  fulfillmentId: fulfillment.id || "",
                  createdAt: fulfillment.createdAt || "",
                });
              }
            });
          }
        });
      },
      viewOrder(order) {
        this.showDetail = true;
        this.orderId = order.id;
        this.lineItems = [];
        theme.addUrlParameters({ orderId: order.id });
        this.fetchOrderDetail();
        this.fetchOrderLine();
      },
      backToList() {
        this.showDetail = false;
        this.orderId = "";
        this.showAllLineItems = false;
        this.order = {};
        this.lineItems = [];
        this.selectedItems = [];
        this.selectAll = false;
        theme.removeUrlParameters(["orderId"]);
        this.fetchGetOrderList();
      },
      // 是否勾选
      isItemSelected(lineId) {
        return this.selectedItems.findIndex((item) => item.id == lineId) != -1;
      },
      // 切换单个项目的选中状态
      toggleItemSelection(lineItem) {
        const index = this.selectedItems.findIndex(
          (item) => item.id == lineItem.id
        );
        if (index === -1) {
          // 如果不在选中列表中，添加
          this.selectedItems.push(lineItem);
        } else {
          // 如果已在选中列表中，移除
          this.selectedItems.splice(index, 1);
        }
        // 更新全选状态
        this.updateSelectAllStatus();
      },

      // 更新全选状态
      updateSelectAllStatus() {
        this.selectAll =
          this.lineItems?.length > 0 &&
          this.selectedItems.length === this.lineItems?.length;
      },

      // 切换全选状态
      toggleSelectAll() {
        this.selectAll = !this.selectAll;
        if (this.selectAll) {
          // 全选：将所有行项目ID添加到选中列表
          this.selectedItems = this.lineItems;
        } else {
          // 取消全选：清空选中列表
          this.selectedItems = [];
        }
      },
      handleWeight(weight) {
        if (weight) return (weight / 1000).toFixed(3);
        return `0.000`;
      },
      handleDate(date) {
        return String(date).replace("T", " ").replace("Z", "");
      },
      handleUrl(handle) {
        return `/products/${handle}`;
      },
    },
    template: `
      <div class="content-list hidden" id="my-order">
        <div v-show="showDetail" class="bg-white padding-20-0">
          <div>
            <div class="account__details padding-0-20">
              <div class="underline cursor-pointer" @click="backToList"><< Back</div>
            </div>
            <div class="flex justify-space-between align-items-end padding-0-20">
              <span class="font-bold font-size-20">Order Number: {{ order?.item?.name }}-<span class="active-color">{{ order?.item?.displayFinancialStatus }}</span></span>
              <div class="re-order-btn cursor-pointer" @click="addSelectedToCart">
                Add To Cart
              </div>
            </div>
            <div class="table padding-0-20">
              <div class="table-row table-header">
                <div class="table-cell check-container flex justify-content-center align-items-center">
                  <div class="check-box" @click="toggleSelectAll" :class="{ check: selectAll }">
                    <img :class="{'hidden': !selectAll}" src="/cdn/shop/t/66/assets/check.png" alt="">
                  </div>
                </div>
                <div class="table-cell flex justify-content-center align-items-center">Thumbnail</div>
                <div class="table-cell flex justify-content-center align-items-center">productId</div>
                <div class="table-cell flex justify-content-center align-items-center">Price</div>
                <div class="table-cell flex justify-content-center align-items-center">Weight</div>
                <div class="table-cell flex justify-content-center align-items-center">Qty</div>
                <div class="table-cell flex justify-content-center align-items-center">Subtotal</div>
                <div class="table-cell flex justify-content-center align-items-center">operation</div>
              </div>
              <div class="table-row font-size-14" v-for="(line, index) in lineItems" :key="line.id" v-show="index < 3 || showAllLineItems">
                <div class="table-cell check-container flex justify-content-center align-items-center">
                  <div class="check-box" :class="{'check': isItemSelected(line?.id)}" @click="toggleItemSelection(line)">
                    <img :class="{'hidden': !isItemSelected(line?.id)}" src="/cdn/shop/t/66/assets/check.png" alt="">
                  </div>
                </div>
                <div class="table-cell flex justify-content-center align-items-center">
                  <a :href="handleUrl(line.product?.handle)" target="_blank">
                    <img
                      v-show="line?.productId"
                      class="thumbnail"
                      :src="line.featuredImage + '?width=65'"
                      loading="lazy"
                      width="65"
                      height="65"
                      alt=""
                    >
                  </a>
                </div>
                <div class="table-cell flex justify-content-center align-items-center">{{ line?.productId}}</div>
                <div class="table-cell flex justify-content-center align-items-center">{{ formatPrice(line?.originalUnitPriceSet?.shopMoney) }}</div>
                <div class="table-cell flex justify-content-center align-items-center">{{ handleWeight(line?.variant?.weight) }}kg</div>
                <div class="table-cell flex justify-content-center align-items-center">{{ line?.quantity }}</div>
                <div class="table-cell flex justify-content-center align-items-center">{{ formatPrice(line?.originalTotalSet?.shopMoney) }}</div>
                <div class="table-cell flex justify-content-center align-items-center" @click="addLineItemToCart(line)">
                  <span class="re-order-btn cursor-pointer" v-if="line?.productId">Add To Cart</span>
                </div>
              </div>
              <div class="flex justify-content-center" v-if="lineItems.length > 3 && !showAllLineItems" @click="showAllLineItems = true">
                <div class="order-more-btn">
                  <span class="icon-caret">
                    <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                    </svg>
                  </span>
                </div>
              </div>
            </div>

            <div class="oder-subtotal text-right padding-0-20">
              <div><span class="subtotal-title">Total Weight:</span><span class="subtotal-content">{{ handleWeight(order?.item?.totalWeight) }}kg</span></div>
              <div><span>Product Quantity:</span> <span class="subtotal-content">{{ order?.item?.subtotalLineItemsQuantity }}</span></div>
              <div>Origin Subtotal: <span class="subtotal-content">{{ formatPrice(order?.item?.originalTotalPriceSet?.shopMoney) }}</span></div>
              <div v-if="order?.item?.totalDiscountsSet?.shopMoney?.amount>0">
                Saving:
                <span class="subtotal-content">
                  <span
                    class="price-item price-item--regular notranslate color-red"
                  >
                    -{{ formatPrice(order?.item?.totalDiscountsSet?.shopMoney) }}
                  </span>
                </span>
              </div>
              <div>
                Subtotal:
                <span
                  class="price-item price-item--regular notranslate subtotal-content"
                >
                  {{ formatPrice(order?.item?.subtotalPriceSet?.shopMoney) }}
                </span>
              </div>
              <div>
                Shipping Fee:
                <span
                  class="price-item price-item--regular notranslate subtotal-content"
                >
                  {{ formatPrice(order?.item?.totalShippingPriceSet?.shopMoney || {amount: 0, currencyCode: order?.item?.totalPriceSet?.shopMoney.currencyCode }) }}
                </span>
              </div>
              <div>
                Total:
                <span
                  class="price-item price-item--regular notranslate subtotal-content"
                >
                  {{ formatPrice(order?.item?.totalPriceSet?.shopMoney) }}
                </span>
              </div>
            </div>
            <div class="order-date font-size-20 font-bold">
              Order Date: {{ handleDate(order?.item?.createdAt) }}
            </div>
            <div class="flex padding-0-20">
              <div class="flex-1">
                <div class="font-bold" v-if="trackingInfo.length">Shipping Method</div>
                <div class="color-666" v-for="tracking in trackingInfo" :key="tracking.number">
                  {{ tracking?.company}} <a :href="tracking?.url" target="_blank" class="underline">{{ tracking?.number }}</a>
                </div>
                <div class="font-bold">Shipping Address</div>
                <div class="color-666">{{ order?.shippingAddress?.name }}</div>
                <div class="color-666">{{ order?.shippingAddress?.address2 }}</div>               
                <div class="color-666">{{ order?.shippingAddress?.city }}</div>
                <div class="color-666">{{ order?.shippingAddress?.province }}</div>            
                <div class="color-666">{{ order?.shippingAddress?.country}}</div>               
                <div class="color-666">{{ order?.shippingAddress?.zip }}</div>
                <div class="color-666">{{ order?.shippingAddress?.phone }}</div>
                
              </div>
              <div class="flex-1">
                <div class="font-bold" v-if="order?.item?.paymentGatewayNames?.length">Payment Method</div>
                <div class="color-666" v-for="payment in order?.item?.paymentGatewayNames" :key="payment">
                  {{ payment }}
                </div>
                <div class="font-bold">Billing Address</div>
                <div class="color-666">{{ order?.billingAddress?.name }}</div>
                <div class="color-666">{{ order?.billingAddress?.address2 }}</div>               
                <div class="color-666">{{ order?.billingAddress?.city }}</div>
                <div class="color-666">{{ order?.billingAddress?.province }}</div>            
                <div class="color-666">{{ order?.billingAddress?.country}}</div>               
                <div class="color-666">{{ order?.billingAddress?.zip }}</div>
                <div class="color-666">{{ order?.billingAddress?.phone }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!showDetail" class="right-content">
          <div class="flex justify-space-between font-size-20 font-bold">
            <div>My Orders</div>
          </div>
          <div class="">
            <div class="flex order-tab cursor-pointer">
              <div class="flex-1" :class="activeIndex == index ? 'active' : ''" v-for="(value, key, index) in ORDER_STATUS" @click="clickTab(index, key)">{{ value }}</div>
            </div>
            <div class="table">
              <div class="table-row table-header">
                <div class="table-cell">Order</div>
                <div class="table-cell">Created Date</div>
                <div class="table-cell">Cancellation Date</div>
                <div class="table-cell">Total</div>
                <div class="table-cell">Payment status</div>
                <div class="table-cell">Fulfillment status</div>
                <div class="table-cell">operation</div>
              </div>
              <div class="table-row font-size-14" v-for="order in orderList">
                <div class="table-cell">
                  <div>{{ order.name }}</div>
                  <div class="font-size-13 active-color cursor-pointer" @click="viewOrder(order)">View Order</div>
                </div>
                <div class="table-cell flex justify-content-center align-items-center">{{ handleDate(order.createdAt) }}</div>
                <div class="table-cell flex justify-content-center align-items-center">{{ order.cancelledAt == '0001-01-01T00:00:00Z' ? '' : handleDate(order.cancelledAt) }}</div>
                <div class="table-cell flex justify-content-center align-items-center">{{ formatPrice(order.totalPriceSet?.shopMoney) }}</div>
                <div class="table-cell flex justify-content-center align-items-center text-lowercase">
                  {{ order.displayFinancialStatus }}
                </div>
                <div class="table-cell flex justify-content-center align-items-center text-lowercase">
                  {{ order.displayFulfillmentStatus }}
                </div>
                
                <div class="table-cell flex justify-content-center align-items-center" @click="addOrderToCart(order.id)">
                  <span class="re-order-btn cursor-pointer">Add To Cart</span>
                </div>
              </div>
            </div>
          </div>
          <div class="pagenation justify-content-center flex" v-if="!nodata">
            <div class="pagenation-btn flex align-items-center justify-content-center border-radius-2 cursor-pointer" @click="prevPage" :disabled="page === 1">
              <img class="pagenation-arrow arrow-left" src="https://assets.gooddiy.com/image/arrow_up.png">
            </div>
            <div class="pagenation-item border-radius-2 notranslate" :class="page==1 ? 'active' : ''" @click="goToPage(1)">1</div>
            <div v-if="showLeftEllipsis" class="notranslate">...</div>
            <div class="pagenation-item border-radius-2 notranslate" :class="pageNumber==page? 'active' : ''" v-for="pageNumber in middlePages" :key="pageNumber" @click="goToPage(pageNumber)">{{ pageNumber }}</div>

            <div v-if="showRightEllipsis" class="notranslate">...</div>
            <div v-if="totalPages > 1" class="pagenation-item border-radius-2 notranslate" :class="page==totalPages ? 'active' : ''" @click="goToPage(totalPages)">{{ totalPages }}</div>
            <div class="pagenation-btn flex align-items-center justify-content-center border-radius-2 cursor-pointer" @click="nextPage" :disabled="page === totalPages">
              <img class="pagenation-arrow arrow-right" src="https://assets.gooddiy.com/image/arrow_up.png">
            </div>
            <div class="margin-left-10">
              Total {{ totalPages }} pages, Go To Page
            </div>
            <div class="input-page pagenation-btn border-radius-2 margin-left-10">
              <input type="number" v-model="inputValue"  @keyup.enter="goToPage(inputValue)"/>
            </div>
          </div>
          <div class="flex justify-content-center align-items-center no-data" v-if="nodata">
            <div>
              <img src="https://assets.gooddiy.com/image/no-data.png">
            </div>
          </div>
        </div>
      </div>
    `,
  });
let order = null;
